import React from "react";
import { theme } from "../../styles";
import { type ColorTheme, FontWeightTheme } from "../../styles/themes/types";
import * as styles from "./styles";

export interface TextProps {
  children: React.ReactNode;
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "p"
    | "caption1"
    | "caption2";
  align?: "left" | "center" | "right";
  color?: keyof ColorTheme | string;
  noMargin?: boolean;
  family?: "sans-serif" | "mono";
  className?: string;
  textTransform?: "capitalize" | "uppercase" | "lowercase" | "none";
  fontVariant?: "small-caps" | "normal" | "inherit" | "initial";

  lineHeight?: number;

  lineClamp?: number;
  letterSpacing?: string;
  weight?: keyof FontWeightTheme;
}

export const Text: React.FC<TextProps> = ({
  children,
  variant = "p",
  align,
  color = "--ll-color-on-background",
  lineClamp,
  noMargin,
  lineHeight,
  weight = "normal",
  family = "sans-serif",
  className,
  textTransform = "none",
  letterSpacing,
  fontVariant = "initial",
}) => {
  // Component needs to change the HTML element with variant
  const elementType = ["caption1", "caption2", "p"].includes(variant)
    ? "p"
    : variant;
  const TextTag = `${elementType}` as keyof JSX.IntrinsicElements;

  const getColor = color in theme ? theme[color as keyof ColorTheme] : color;

  return (
    <TextTag
      style={{
        color: `${getColor}`,
        fontVariant: `${fontVariant}`,
        lineHeight: lineHeight || "1.45",
        letterSpacing: `${letterSpacing}`,
        fontWeight: theme[weight as keyof FontWeightTheme],
      }}
      className={`${className} ${styles.container}`}
      data-align={align}
      data-variant={variant}
      data-texttransform={textTransform}
      data-family={family}
      data-nomargin={noMargin}
      data-lineclamp={lineClamp}
    >
      {children}
    </TextTag>
  );
};
